import { FC } from "react";
import { TableCell, TableRow, Typography, makeStyles } from "@material-ui/core";

interface XlsxRenderRowProps {
  user_name?: string;
  badge?: string | null;
  station?: string;
  agency?: string;
  date?: string;
  role?: number | null;
  role_hours?: number | null;
  pay_rate?: number | null;
  pay?: number | null | string;
  agency_pay?: string | number;
  comment?: string;
  is_total_table?: boolean;
  is_total_row?: boolean;
}

export const PayrollRenderRow: FC<XlsxRenderRowProps> = ({
  user_name,
  badge,
  station,
  agency,
  date,
  role,
  role_hours,
  pay_rate,
  pay,
  agency_pay,
  comment,
  is_total_table,
  is_total_row,
}) => {
  const classes = useStyles();

  return (
    <TableRow className={is_total_row ? classes.row : ""}>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{user_name}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{badge}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{station}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{agency}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{date}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{role}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{role_hours}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{pay_rate}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{pay}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{agency_pay}</Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography variant="body2">{comment}</Typography>
      </TableCell>
    </TableRow>
  );
};

const useStyles = makeStyles((theme) => ({
  row: { background: "#E0E0E0" },
  cell: { color: "black", border: "solid 1px gray", height: 20 },
}));
